import { type Route } from '#app/routes/mocra+/_sections+/+types/overview.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — Compliance Overview' },
]

export default function SectionOverview() {
	return <SectionDetail section={SECTIONS.overview} />
}
